// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"624133b5","203":"44307d0c","620":"110cac66","693":"d10b62d0","875":"3438c92a"}[chunkId] + ".chunk.css";
};